import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SplitSheetModalService } from 'src/app/shared/services/split-sheet-modal.service';
import { DateRange } from '../../../data/adapters/shipping-accounting-filter.adapter';
import { SendShippingEmailRequest, ShippingAccounting } from '../../../domain/entities/shipping-accounting.entity';

@Component({
  selector: 'app-shipping-accounting-send-modal',
  templateUrl: './shipping-accounting-send-modal.component.html',
  styleUrls: ['./shipping-accounting-send-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingAccountingSendModalComponent implements OnInit, OnChanges, OnDestroy {
  readonly MODAL_NAME = 'shippingAccountingSendMail';

  @Input() item: ShippingAccounting | null = null;
  @Input() dateRange: DateRange = { start: '', end: '' };
  @Input() sending = false;

  @Output() readonly submitted = new EventEmitter<SendShippingEmailRequest>();
  @Output() readonly cancel = new EventEmitter<void>();

  readonly onlyPendingOptions = [
    { label: 'Todas', value: false },
    { label: 'Apenas "Não enviadas"', value: true },
  ];

  readonly form = new FormGroup({
    mail: new FormControl('', [Validators.required, Validators.email]),
    onlyPending: new FormControl<boolean | null>(null, [Validators.required]),
  });

  private isOpen = false;
  private modalSub = Subscription.EMPTY;

  constructor(private readonly splitSheetModalService: SplitSheetModalService) {}

  ngOnInit(): void {
    this.modalSub = this.splitSheetModalService.modalSubject.subscribe((event) => {
      if (event.action === 'CLOSE' && this.isOpen) {
        this.isOpen = false;
        this.cancel.emit();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item']) {
      if (this.item) {
        this.form.reset({ mail: this.item.email, onlyPending: null });
        this.isOpen = true;
        this.splitSheetModalService.push(this.MODAL_NAME);
      } else if (!this.isOpen) {
        // item cleared by parent after external close — nothing to do
      } else {
        this.isOpen = false;
        this.splitSheetModalService.close(this.MODAL_NAME);
      }
    }
  }

  ngOnDestroy(): void {
    this.modalSub.unsubscribe();
  }

  onSubmit(): void {
    if (this.form.invalid || !this.item) {
      this.form.markAllAsTouched();
      return;
    }

    const { mail, onlyPending } = this.form.getRawValue();

    this.submitted.emit({
      professionalIri: `/api/professionals/${this.item.professionalId}`,
      email: mail ?? '',
      startDate: this.dateRange.start,
      endDate: this.dateRange.end,
      onlyPending: onlyPending ?? false,
    });
  }
}
